import { InfoPopover } from "@/components/cinch/InfoPopover";
import { KpiTile, tonePct } from "@/components/cinch/KpiTile";

import type { ForecastResponse } from "../../api";
import { fmtCur, fmtPct } from "../../format";

/** CSM forecast totals across the 25-month window — a coverage gauge. */
export function CsmForecastSummary({ data }: { data: ForecastResponse }) {
  const t = data.totals;
  const covTone = tonePct(t.coverage_pct, 70, 40);
  const called = (t.renew || 0) + (t.at_risk || 0) + (t.churn || 0);
  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <h2 className="text-lg font-semibold">CSM Forecast — Summary</h2>
        <InfoPopover title="CSM Forecast — Summary">
          <p>Counts and ARR sums across the 25-month window (12 back + current + 12 forward), bucketed by CSM forecast pick.</p>
          <p><b>Coverage %</b> = (Renew + Renewal At Risk + Churn) ÷ upcoming-count. Measures how much of the future book the team has formed a view on.</p>
        </InfoPopover>
      </div>
      <p className="-mt-2 text-xs text-muted-foreground">
        25-month window · the cohort table below has the by-month breakdown
      </p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <KpiTile
          label="Forecast Renew"
          value={t.renew}
          tone="positive"
          sub={`${fmtCur(t.renew_arr)} ARR`}
        />
        <KpiTile
          label="Renewal At Risk"
          value={t.at_risk}
          tone="warning"
          sub={`${fmtCur(t.at_risk_arr)} ARR`}
        />
        <KpiTile
          label="Forecast Churn"
          value={t.churn}
          tone="danger"
          sub={`${fmtCur(t.churn_arr)} ARR`}
        />
        <KpiTile
          label="Coverage"
          value={fmtPct(t.coverage_pct)}
          tone={covTone}
          sub={`${called} of ${t.upcoming_count} upcoming called`}
        />
      </div>
    </section>
  );
}
